`use strict`;

class Draad_Toggle {

    constructor(domNode) {

        this.toggle = domNode;
        this.target = document.getElementById(this.toggle.getAttribute('aria-controls'));

        this.toggle.addEventListener('click', () => { this.toggleTarget() });

    }

    toggleTarget() {

        const open = new CustomEvent('DraadToggleOpen');
        const close = new CustomEvent('DraadToggleClose');

        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
            this.toggle.setAttribute('aria-expanded', 'false');
            this.target.setAttribute('aria-hidden', 'true');
            this.target.setAttribute('hidden', 'hidden');
            this.toggle.focus();

            this.toggle.dispatchEvent(close);
        } else {
            this.toggle.setAttribute('aria-expanded', 'true');
            this.target.setAttribute('aria-hidden', 'false');
            this.target.removeAttribute('hidden');
            this.target.focus();

            this.toggle.dispatchEvent(open);
        }

    }

}